import { ORG_INFO_SESSION_STORAGE, USER_INFO_SESSION_STORAGE } from '../constants/constants';

export const initializePendo = () => {
	const userInfo = JSON.parse(sessionStorage.getItem(USER_INFO_SESSION_STORAGE) as string);
	const userOrg = JSON.parse(sessionStorage.getItem(ORG_INFO_SESSION_STORAGE) as string);
	if (typeof pendo === 'object') {
		pendo.initialize({
			visitor: {
				firstName: userInfo?.firstName,
				lastName: userInfo?.lastName,
				email: userInfo?.email,
				id: userInfo?.id,
				domain: userInfo?.email.split('@')[1],
			},
			account: {
				id: userOrg?.clientId,
				name: userOrg?.name,
			},
		});
	}
};
